import Vue from 'vue'
import VueRouter from 'vue-router'
import authGuard from './AuthGuard'

Vue.use(VueRouter)
const routes = [
    {
        name: 'home',
        path: '/',
        component: () => import('../pages/Home'),
        beforeEnter: authGuard
    },
    {
        name: 'login',
        path: '/auth/login',
        component: () => import('../pages/auth/Login'),
    },
    {
        name: 'create-user',
        path: '/auth/create',
        component: () => import('../pages/auth/CreateUser'),
        beforeEnter: authGuard
    },

    /** Car */
    {
        name: 'create-car',
        path: '/car/create',
        component: () => import('../pages/car/NewCar'),
        beforeEnter: authGuard
    },
    {
        name: 'car-list',
        path: '/car/car-list',
        component: () => import('../pages/car/CarsList'),
        beforeEnter: authGuard
    },
    {
        name: 'edit-car',
        path: '/car/car-edit/:carId',
        component: () => import('../pages/car/EditCar'),
        beforeEnter: authGuard
    },
    {
        name: 'car-info',
        path: '/car/car-info/:carId',
        component: () => import('../pages/car/CarInfo'),
        beforeEnter: authGuard
    },

    /** Client */
    {
        name: 'new-client',
        path: '/client/new-client',
        component: () => import('../pages/client/NewClinet'),
        beforeEnter: authGuard
    },
    {
        name: 'black-list',
        path: '/client/black-list',
        component: () => import('../pages/client/BlackList'),
        beforeEnter: authGuard
    },


    /** Company */
    {
        name: 'new-company',
        path: '/client/add-company',
        component: () => import('../pages/client/NewCompany'),
        beforeEnter: authGuard
    },


    /** Order */
    {
        name: 'new-order',
        path: '/new-order/:carId',
        component: () => import('../pages/order/NewOrder'),
        beforeEnter: authGuard
    },
    {
        name: 'not-issued',
        path: '/order/not-issued',
        component: () => import('../pages/order/NotIssued'),
        beforeEnter: authGuard
    },
    {
        path: '/order/:id([0-9]*)',
        component: () => import('../pages/order/CreateIssuedOrder'),
        beforeEnter: authGuard
    },
    {
        name: 'active-orders',
        path: '/order/active/list',
        component: () => import('../pages/order/ActiveOrder'),
        beforeEnter: authGuard
    },
    {
        name: 'order-edit',
        path: '/order/edit/:orderId',
        component: () => import('../pages/order/EditOrder'),
        beforeEnter: authGuard
    },
    {
        name: 'order-accept',
        path: '/order/accept/:orderId',
        component: () => import('../pages/order/AcceptOrder'),
        beforeEnter: authGuard
    },
    {
        path: '/order/print/:id',
        component: () => import('../pages/order/PrintOrder'),
        beforeEnter: authGuard
    },
    {
        path: '/order/add-photo/:orderId/:carId',
        component: () => import('../pages/order/AddPhotoOrder'),
        beforeEnter: authGuard
    },
    {
        name: 'statistics',
        path: '/order/statistics-car',
        component: () => import('../pages/order/Statistic'),
        beforeEnter: authGuard
    },

    /** services */
    {
        name: 'new-service',
        path: '/services/add',
        component: () => import('../pages/services/AddService'),
        beforeEnter: authGuard
    },

    {
        name: 'booking',
        path: '/booking',
        component: () => import('../pages/Booking'),
        beforeEnter: authGuard
    },

    // {
    //     name: 'test',
    //     path: '/test/f4aa3ed9ec9f50b678b399ac4b604986',
    //     component: () => import('../pages/TestUpload'),
    // },

]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
